<template>
  <div>
    <Breadcrumb :title="'Investment Valuation'"></Breadcrumb>
    <InvestmentValuationForm :ref="'InvestmentValuationForm'"  :InvestmentInfo="InvestmentJSON" :InvestmentModalLabel="modalConfig" @SaveComplete="refreshGrid">
    </InvestmentValuationForm>
    <div>
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    </div>
    <div class='btnDiv'>
      <BaseToolBar :config="ToolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
      <BaseGrid :config="GridConfig" :excelExport="excelExport" :mode="'editform'" @EditItem="EditInvestment" :data="InvestmentInfoData" 
                @AttachItem="InvestmentAttachment"></BaseGrid>
    </div>
    <InvestmentDocumentDropoffForm
      ref="investmentDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedInvestment"
    ></InvestmentDocumentDropoffForm>
  </div>
</template>

<script>
import $ from 'jquery';
import { GridConfig, ToolbarConfig }  from "./InvestmentValuationConfig.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseModelInputControl  from "@/models/BaseModelInputControl.js";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import InvestmentValuationForm from "@/components/forms/InvestmentValuationForm.vue";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import { mapGetters, mapActions, mapState } from 'vuex';

import InvestmentDocumentDropoffForm from "@/components/forms/InvestmentDocumentDropoffForm.vue";

export default {
  name: "InvestmentValuation",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    InvestmentValuationForm,
    InvestmentDocumentDropoffForm
  },
  computed:{
    ...mapGetters("getModule",["withFilter","getAllItemFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),
  },
  data: function () {
    return {
      GridConfig: GridConfig,
      grid: $("#" + GridConfig.grid.gridId).data("kendoGrid"),
      search: {
        SearchData: "",
      },
      InvestmentValuationGridId: "InvestmentValuationGrid",
      InvestmentMasterData: {},
      ToolbarConfig: ToolbarConfig,
      BaseModelInvestment: BaseModelInvestment,
      BaseModelInvestmentValuation:BaseModelInvestmentValuation,
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelProgram: BaseModelProgram,
      BaseModelInputControl:BaseModelInputControl,
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      InvestmentJSON:  {
        parent:{},
        children:{}
      },
      // InvestmentAddJSON: {
      //Id: "",
      // BusinessEvent:"",
      // ProgramId:"",
      // ReceiverId:"",
      // ProgramTitle:"",
      // ReceiverFullName:"",
      // UnitClass:"",
      // UnitType:"",
      // UnitPool:"",
      // Unit:"",
      // TransactionDate:"",                        
      // },
      InvestmentEditJSON: {
        parent:{
        Id: "",
        InvestmentID:"",
        Title:"",
        InvestmentGroup:"",
        StatementOrder:"",        
        Note: "",        
        },
        children:{
        InvestmentValuation:[],
        }
      },
      InvestmentData:[],
      InvestmentValuationData:[],
      InvestmentInfoData:[],    
      dropdowns: {
        TaxPeriod: { model: "", dataSource: [] },        
      },
      // Document dropoff modal
      docModalConfig: {
        modalName: "Investment Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedInvestment:{}
    }
  },
  mounted() {
    const self = this;

    // if(Object.keys(this.$route.query)[0] == "InitailIssuace"){
    //   $('#btnAddInvestment').click();
    //   $('#backTo').removeClass('d-none');
    // }
    //changes for Toolbar    
    //self._loadGridSettings(self.InvestmentValuationGridId);
    $("#dropdownPeriod").bind("change",self.PeriodChangedEventHandler); 

    //self.getInputControls();
    self.getBaseGridData();
    //get the data from Investment and InvestmentValuation table. Combine to form the Investment Info Grid    
    self.getCombinedInvestmentData();
     
    
    //bind databound event to grid
    const grid = $("#InvestmentValuationGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateInvestmentMasterData);
    // grid.dataSource.fetch();

    
        
    
  },
  methods: {
    ...mapActions("postModule",['DeleteItem']), 

    async getBaseGridData(){
      await this.getInputControls();
      this._loadGridSettings(this.InvestmentValuationGridId);
    },
    PeriodChangedEventHandler(e){
      if(e != null && e!=undefined){
        e.preventDefault();
      }
      let self = this;      
      // alert($('#dropdownPeriod').val());
      var selectedPeriod = $('#dropdownPeriod').val();
      if(selectedPeriod != null && selectedPeriod != undefined){           
        self.InvestmentInfoData=[];
        self.InvestmentData.forEach(InvestmentItem => {
          let IVFilteredData = this.InvestmentValuationData.filter(item =>{return item.InvestmentId == InvestmentItem.Id});
          let InvestmentCombinedItem = InvestmentItem;
          InvestmentCombinedItem.ProjectedValue="";
          InvestmentCombinedItem.CurrentValue="";
          let IVTaxYearQuarterFilteredData = IVFilteredData.filter(item =>{return item.TaxYearQuarter == selectedPeriod});
          if(IVTaxYearQuarterFilteredData.length > 0){
            InvestmentCombinedItem.ProjectedValue=IVTaxYearQuarterFilteredData[0].ProjectedValue;
            InvestmentCombinedItem.CurrentValue=IVTaxYearQuarterFilteredData[0].CurrentValue;
          }                   
          self.InvestmentInfoData.push(InvestmentCombinedItem);
        });              
      }
      // else{
      //   self.getDefaultPeriodInvestmentData();
      // }

    },

    async getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      // await self._getInputControls().then(response => {
        // let response = self.withFilter("InputControl");
        console.log(response);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
          // self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
        });

        //Filling the Drop down options for the Grid DropDown Columns
        // this.toolbarDropDowns.TaxPeriod= this.dropdowns.TaxPeriod.dataSource;
        // let options = '<option value="1">One</option>';
        // $('#dropdownPeriod').empty();
        // let options ='';
        // if(self.dropdowns.TaxPeriod.dataSource.length > 0){
        //   for (let index = 0; index < self.dropdowns.TaxPeriod.dataSource.length; index++) {
        //     const optionvalue = self.dropdowns.TaxPeriod.dataSource[index];
        //     //select the recent value
        //     if(self.dropdowns.TaxPeriod.dataSource.length - index == 1){
        //       options = options +  '<option value="'+ optionvalue.Option +'" selected >'+ optionvalue.Option +'</option>';
        //     }else{
        //       options = options +  '<option value="'+ optionvalue.Option +'">'+ optionvalue.Option +'</option>';
        //     }   
        //   }               
        //   $('#dropdownPeriod').append(options);
        if(self.dropdowns.TaxPeriod.dataSource != undefined) {
            if (self.dropdowns.TaxPeriod.dataSource.length>0)
            {
                self.dropdowns.TaxPeriod.dataSource= _.orderBy(self.dropdowns.TaxPeriod.dataSource,['Option'], ['asc']);
            }
            $("#dropdownPeriod").kendoDropDownList({
                dataSource: self.dropdowns.TaxPeriod.dataSource,
                dataTextField: "Option",
                dataValueField: "Option"
            });
            if(self.dropdowns.TaxPeriod.dataSource.length > 0){
            // get a reference to the dropdown list and assign the latest value
            let dropdownlist = $("#dropdownPeriod").data("kendoDropDownList");
            dropdownlist.select(self.dropdowns.TaxPeriod.dataSource.length-1);
          }
          self.PeriodChangedEventHandler();
       }else{
          self.getDefaultPeriodInvestmentData();
       }
    // });      
    },

    getCombinedInvestmentData: function(){
      const self = this;      
      // self.getAllItemFilter({
      //   Investment: { config: BaseModelInvestment },
      //   InvestmentValuation: { config: BaseModelInvestmentValuation }
      // }).then( (response) => {

      // self._getAllItems({
     let response=  self.getAllItemFilter({        
        Investment: { config: BaseModelInvestment },
        InvestmentValuation: { config: BaseModelInvestmentValuation }
      })
      if(response){      
        console.log('async _getAllItems', response)
        self.InvestmentData = response.Investment;
        self.InvestmentValuationData = response.InvestmentValuation;        
      }
      // self.getInputControls();
      self.PeriodChangedEventHandler();
    },

     getDefaultPeriodInvestmentData: function(){
      //get the data from Investment and InvestmentValuation table. Combine to form the Investment Info Grid    
      this.InvestmentInfoData=[];
      this.InvestmentData.forEach(InvestmentItem => {
        let InvestmentCombinedItem = InvestmentItem;
        InvestmentCombinedItem.ProjectedValue="";
        InvestmentCombinedItem.CurrentValue="";   
        this.InvestmentInfoData.push(InvestmentCombinedItem);
      });       
    },

    UpdateInvestmentMasterData: function (fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.InvestmentMasterData = filterMasterData;
      } else {
        this.InvestmentMasterData = JSON.parse(JSON.stringify($("#InvestmentValuationGrid").data().kendoGrid.dataSource.data()));
      }
    },

    toolbarOnClick: function (e) {
      e.preventDefault();
      switch (e.id) {
        case "btnAddInvestment":
          this.AddInvestment();
          window.$("#BaseModal").modal("toggle");
          break;
        case "backTo":
          this.$router.push("/event/initialissuance");
          break;
        // case "btnApproveInvestment":
        //   this.ApproveInvestment();
        //   break;
        case "btnBulkImportUnitInvestmentValuation":
          // this._AlertPopup("Bulk import screen is in progress...");   
          this.$router.push("/valuation/investmentvaluation/upload");       
          break; 
        case "btnRefresh":
          this.refreshGrid();
          break;
      }
      this._baseToolBarEvents("InvestmentValuationGrid", ...arguments);
    },
    refreshGrid: function(){        
      this.getCombinedInvestmentData();    
        // $("#InvestmentValuationGrid").data().kendoGrid.dataSource.read();
        // alert("Data Refreshed!");

    },
   
    filterGrid: function () {
      let self = this;
      // this.ProgramInfoFormJSON = $("#programGrid").data().kendoGrid.dataSource.view()
      // var displayedData = $("#programGrid").data().kendoGrid.dataSource.view()
      //Then stringify it as follows:
      // var displayedDataAsJSON = JSON.stringify(displayedData); 
      //alert(displayedDataAsJSON );
      var currentMasterdata = this.InvestmentMasterData;

      let filteredData = this._filterGrid(this.InvestmentMasterData, this.search.SearchData);
      //Filter by a column
      // let filteredData=this._filterGridbyColumn(parentGridData,"StartDate",this.searchData);
      //this.parentdata = filteredData;
      $("#InvestmentValuationGrid").data("kendoGrid").dataSource.data(filteredData);
      this.UpdateInvestmentMasterData(true, currentMasterdata);
    },
    AddInvestment: function () {
      this.modalConfig.modalName = "Add Investment";
      this.modalConfig.modalAddorEdit = "add";      
      var InvestmentAddJSON = {
        parent:{
        Id: "",
        InvestmentID:"",
        Title:"",
        InvestmentGroup:"",
        StatementOrder:"",        
        Note: "",        
        },
        children:{
        InvestmentValuation:[],
        }
      } ;
      this.$refs.InvestmentValuationForm.IVDeleteItemsArray=[];  
      this.$refs.InvestmentValuationForm.pageErrors=[];
      this.InvestmentJSON = InvestmentAddJSON;
      // this.InvestmentAddJSONId = "";          
      // this.$refs.ProgramInfo.$refs.refProgramForm.errors.clear();             
    },
    EditInvestment: function (e) {
      let self = this;
      e.preventDefault();
      this.modalConfig.modalName = "Edit Investment Valuation";
      this.modalConfig.modalAddorEdit = "edit";
      //alert("Edit button clicked from BaseGrid..");  
      var gview = window.$("#InvestmentValuationGrid").data("kendoGrid");
      // var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      var dataItem = JSON.parse(JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr"))));
      this.$refs.InvestmentValuationForm.IVDeleteItemsArray=[];
      this.$refs.InvestmentValuationForm.pageErrors=[];      
      // alert(JSON.stringify(dataItem));      
      // self.InvestmentEditJSON.parent = dataItem;
      // self.InvestmentEditJSON.children.InvestmentValuation=[];

      // this._getItems(BaseModelInvestmentValuation, {
      //   filter: "Investment/Id eq " + dataItem.Id
      // }).then(response => {

       let response =  this.withFilter(BaseModelInvestmentValuation.list, {filter: "Investment/Id eq " + dataItem.Id});
        console.log("IV", response);
        // self.InvestmentEditJSON.parent = dataItem;
        self.InvestmentEditJSON.parent.Id = dataItem.Id;
        self.InvestmentEditJSON.parent.Title =dataItem.Title;
        self.InvestmentEditJSON.parent.InvestmentID =dataItem.InvestmentID;  
        // this.$refs.InvestmentValuationForm.InvestmentAutoCompleteDisplayedValue=dataItem.Title;  
        // self.InvestmentEditJSON.parent.InvestmentGroup = dataItem.InvestmentGroup;      
        // self.InvestmentEditJSON.parent.StatementOrder =dataItem.StatementOrder;     
        // self.InvestmentEditJSON.parent.Note = dataItem.Note;        
        self.InvestmentEditJSON.children.InvestmentValuation=response;
        self.InvestmentJSON = self.InvestmentEditJSON;    
        console.log("InvestmentJSON" , self.InvestmentJSON)  ;
        window.$("#BaseModal").modal("toggle");
      // });
      

    },
    DeleteItemfromGrid: function (e) {
      e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message,"DELETE").then((result) => {
        if (result.value) {
          var gview = window.$("#InvestmentValuationGrid").data("kendoGrid");
          var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
          //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
          // alert(JSON.stringify(dataItem));
          //Delete Investment items from the grid                        
          let deleteData = {
            "Id": dataItem.Id
          }
          let items = { list:GridConfig, payload:deleteData }
          this.DeleteItem(items).then((res) => {
              this.refreshGrid();
            this._AlertPopup("Deleted successfully!","success");
          }).catch(error=>{
            this._AlertPopup("Some Error Occurred!","info");
          })
        }
      });
    },
    // Investment Documnet Dropoff
    InvestmentAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#InvestmentValuationGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedInvestment={...dataItem};
            //TEMP: Only for Transfer Page.. Building Partner Record for the Time Being
      this.selectedInvestment.PartnerTitle=null,
      this.selectedInvestment.PartnerId=null,
      this.selectedInvestment.PartnerTitle=null,
      this.selectedInvestment.PartnerId=null
      this.selectedInvestment.TransactionID=dataItem.Id
      this.selectedInvestment.BusinessEvent="Investment"

      this.filterCondition.filter = `BusinessEvent eq 'Investment' and TransactionID eq ${
        dataItem.Id
      }`;

      this.$refs.investmentDocument.$refs.investmentDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    }

  },
}
</script>
